<template>
    <div>
        <div class="row">
            <div class="col-5">
                <b>{{ question }}</b>
            </div>
            <div class="col-7">
                <ValidationProvider
                  v-slot="{ errors, validated }"
                  rules="required"
                >
                    <CustomCheckboxGroup
                        v-model="model.answers"
                        :options="options"
                        :disabled="disabled"
                        :has-error="validated && !!errors.length"
                        error-message="Al menos una opción es requerida"
                    />
                </ValidationProvider>
            </div>
        </div>
        <div v-if="isCommentRequired">
            <ValidationProvider
                v-slot="{ errors }"
                rules="required"
            >
                <CustomTextArea
                    v-model="model.comment"
                    :disabled="disabled"
                    label="Indique razón por la que el equipo se encuentra o viaja al Hogar:"
                    placeholder="Comentario"
                    :rows="2"
                    :maxlength="3000"
                    class="my-4"
                    :error="errors[0]"
                    custom-error-msg="Comentario es requerido"
                />
            </ValidationProvider>
        </div>
    </div>
</template>
<script>
import CustomTextArea from 'CustomTextArea';
import { ValidationProvider } from "vee-validate";
import CustomCheckboxGroup from "@/views/pei/atEquipment/common/CustomCheckboxGroup.vue";

const OPTION_REQUIRE_COMMENT = 'home';

export default {  
    name: "LocationQuestion",
    components: {
        CustomTextArea,
        ValidationProvider,
        CustomCheckboxGroup
    },
    props: {
        value: {
            type: Object,
            required: true,
            default: () => ({
                answer: "",
                comment: "",
            }),
        },
        question: {
            type: String,
            required: true,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false
        },
    },
    data: () => ({
        model: {
            answers: [],
            comment: "",
        },
        options: [
            { label: 'Escuela', value: 'school' },
            { label: 'Sala Regular', value: 'regular-school' },
            { label: 'Salón de<br>Educación Especial', value: 'school-special-education' },
            { label: 'Servicios Relacionados de Terapias', value: 'therapy-services' },
            { label: 'Hogar', value: OPTION_REQUIRE_COMMENT },
        ]
    }),
    computed: {
        isCommentRequired() {
            return this.model.answers.includes(OPTION_REQUIRE_COMMENT);
        }
    },
    watch: {
        value: {
            deep: true,
            immediate: true,
            handler(newValue) {
                this.model.answers = newValue.answer.split(',').map(s => s.trim());;
                this.model.comment = newValue.comment;
            }
        },
        model: {
            deep: true,
            handler(newValue) {
                const payload = {
                    answer: newValue.answers.map(s => s.trim()).join(','),
                    comment: this.isCommentRequired ? newValue.comment : "",
                };
                
                if (payload.answer !== this.value.answer || payload.comment !== this.value.comment) {
                    this.$emit('input', payload);
                }
            }
        },
    },
};
</script>

<style scoped>
</style>